import { Injector, Component, OnInit, Input } from '@angular/core';
import { EventsComponent } from '../events/events.component';
import { isEmpty } from 'lodash';

@Component({
	selector: 'filled-data',
	template: `
		<div class="filled-data-container">
			<div class="filled-data-option" *ngFor="let option of control.attributes.data">
				<div class="filled-data-title">
					{{ option.title }}
				</div>

				<div class="filled-data-value">
					{{ getConcatenatedValue(option.dataNames) }}
				</div>
			</div>
		</div>

		<button
			class="edit-button"
			(click)="setAnswer(true)"
			[disabled]="control.disabled"
			gtm-handler
			[attr.gtm]="gaLabel"
			events="click"
			handlerType="button"
			[label]="gaLabel"
			action="ButtonClick"
		>
			<span>Edit </span><i class="icon-pencil"></i>
		</button>
	`,
	styleUrls: ['./filled-data.component.scss'],
})
export class FilledDataComponent extends EventsComponent implements OnInit {
	constructor(injector: Injector) {
		super(injector);
	}

	ngOnInit() {
		this.gaLabel = this.getGaLabel(this.control);
		if (this.value) {
			this.reportPrefill();
		}
		this.control.attributes.value = true;
	}

	getConcatenatedValue(dataNames) {
		const ansArr = [];

		dataNames.forEach((name) => {
			const answer = this.storeService.getValue(name, this.context);

			if (answer && !isEmpty(answer)) {
				ansArr.push(answer);
			}
		});

		return ansArr.join(' ');
	}
}
